import { Container } from '../../ui'
import {useDispatch} from "react-redux";
import {openWindow} from "../../models/window/actions";
import {modalNames} from "../common/modal/constants/names";

import banner from './assets/images/about-banner.png'

import c from './assets/sass/about.module.scss'

const About = () => {
    const dispatch = useDispatch()

    const bookHandler = () => {
        dispatch(openWindow(modalNames.CONTACT_MODAL))
    }

    return (
        <section id="about" className={c.component}>
            <Container>
                <div className={c.title}>О нас</div>
                <div className={c.subtitle}>DL Massage</div>
                <div className={c.bottom}>
                    <div className={c.left}>
                        <div className={c.text}>
                            DL Massage - это массажный салон, который предлагает
                            различные виды массажа, включая ручной и аппаратный,
                            а также спа-процедуры и солярий.
                        </div>
                        <ul className={c.list}>
                            <li className={c.item}>Уютная атмосфера</li>
                            <li className={c.item}>
                                Сертифицированные специалисты
                            </li>
                            <li className={c.item}>Индивидуальный подход</li>
                            <li className={c.item}>Удобное расположение</li>
                            <li className={c.item}>Качественные процедуры</li>
                        </ul>
                        <div className={c.info}>
                            <div className={c.infoTitle}>
                                <strong>-20%</strong> на первый визит на
                                антицеллюлитный массаж
                            </div>
                            <button className={c.button} onClick={bookHandler}>Записаться</button>
                        </div>
                    </div>
                    <img src={banner} alt="Banner" />
                </div>
            </Container>
        </section>
    )
}

export default About
